export default function AppearanceSettings({
  accentThemeOptions,
  draft,
  onAccentColorChange,
  onThemeModeChange,
  themeModeOptions,
  t = {}
}) {
  return (
    <div className="panel">
      <div className="section-heading">
        <div>
          <p className="eyebrow">{t.appearance || "Appearance"}</p>
          <h3>{t.theme || "Theme"}</h3>
        </div>
      </div>
      <div className="segmented-control">
        {themeModeOptions.map((mode) => (
          <button
            className={draft.themeMode === mode.value ? "is-selected" : ""}
            key={mode.value}
            onClick={() => onThemeModeChange(mode.value)}
            type="button"
          >
            {mode.text}
          </button>
        ))}
      </div>
      <div className="swatch-row" aria-label={t.accentColor || "Accent color"}>
        {accentThemeOptions.map((theme) => (
          <button
            aria-label={theme.text}
            className={draft.accentColor === theme.value ? "is-selected" : ""}
            key={theme.value}
            onClick={() => onAccentColorChange(theme.value)}
            style={{ background: theme.value }}
            type="button"
          />
        ))}
      </div>
    </div>
  );
}
